import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-sales-top-up-loan-success-message',
  templateUrl: './sales-top-up-loan-success-message.component.html'
})
export class SalesTopUpLoanSuccessMessageComponent {
  @Output() navigateEvent = new EventEmitter();

  navigateToVerificationClient(){
    this.navigateEvent.emit();
  }
}
